import { PDFLayout } from "ui/components/PDF";
import ItemTable from "./components/ItemTable/index";
import { View } from "@react-pdf/renderer";
import { OrcamentoItemPdfResponse } from "features/orcamento/typings";
import moment from "moment";

interface PDFItensOrcamentoProps {
  data?: OrcamentoItemPdfResponse;
  includeDocumentWrapper?: boolean;
}

function PDFItensOrcamento({
  data,
  includeDocumentWrapper = true,
}: PDFItensOrcamentoProps) {
  return (
    <PDFLayout
      fontSize={7}
      includeDocument={includeDocumentWrapper}
      assinaturas={data?.assinaturas}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Itens a serem cotados`,
        subTitle: `Emitido em  ${moment().format(
          "DD/MM/YYYY [às] HH:mm [horas]"
        )}`,
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      {data?.orcamentoItems ? (
        <View>
          <ItemTable item={data.orcamentoItems} />
        </View>
      ) : null}
    </PDFLayout>
  );
}

export default PDFItensOrcamento;
